import { Provider } from '@angular/core';

import { SystemMessagingHubService } from './lib/services';
import { ErrorNotificationService } from './lib/services/error-notification.service';
import { SystemNotificationService } from './lib/services/system-notification.service';

export * from './lib/components';
export * from './lib/services';

export function provideSystemMessaging(): Provider[] {
  return [SystemNotificationService, SystemMessagingHubService, ErrorNotificationService];
}
